import { Component, Input, OnInit } from '@angular/core';
import * as c3 from 'c3';
import * as d3 from 'd3';

@Component({
	selector: 'app-eachbar',
	templateUrl: './eachbar.component.html',
	styleUrls: ['./eachbar.component.css'],
})
export class EachbarComponent implements OnInit {
	@Input() data: any;
	constructor() {}

	ngOnInit(): void {}

	ngAfterViewInit() {
		let barData = [];
		let colorPattern = [];
		let schoolColor = ['#1492B7'];
		let classColor = ['#1492B7'];
		colorPattern[1] = classColor;
		colorPattern[2] = schoolColor;
		barData.push(this.data.data.xBarName); //column name exists.
		let colDataMap = this.data.data.columnData;
		let currentTravIndex = 0;
		for (let eachIndex of Object.keys(colDataMap)) {
			currentTravIndex += 1;
			let targetIndex = parseInt(eachIndex);
			let targetValue = colDataMap[eachIndex];
			while (targetIndex > currentTravIndex - 1) {
				barData.push(0);
				currentTravIndex += 1;
			}
			if (targetIndex == currentTravIndex - 1) {
				barData.push(targetValue);
			}
		}
		let yTicks = [];
		let kidsCount = this.data.data.yMax;
		if (kidsCount >= 1) {
			let smallestTick = Math.ceil(kidsCount / 10);
			let i = 1;
			while (smallestTick * i <= kidsCount) {
				yTicks.push(smallestTick * i);
				i += 1;
			}
		}
		let chart = c3.generate({
			bindto: '.barchart-' + this.data.id,
			data: {
				columns: [barData],
				type: 'bar',
			},
			legend: {
				hide: true,
			},
			axis: {
				y: {
					// max: this.data.data.yMax,
					label: {
						text: this.data.data.yLabel,
						position: 'outer-middle',
					},
					tick: {
						format: function (d) {
							return parseInt(d) == d ? d : null;
						},
						values: yTicks,
					},
				},
				x: {
					max: this.data.data.xMax,
					label: {
						text: this.data.data.xLabel,
						position: 'outer-center',
					},
					tick: { values: this.data.data.xTickValues },
					type: 'category',
					//categories: this.data.data.categories,
				},
			},
			grid: {
				y: {
					show: true,
				},
			},
			bar: {
				width: {
					ratio: 0.8,
				},
			},
			tooltip: {
				format: {
					title: function (d) {
						return d == 0
							? 'Baseline'
							: d <= 1
							? d + '&nbsp;Challenge'
							: d + '&nbsp;Challenges';
					},
				},
			},
			color: {
				pattern: colorPattern[this.data.unitType],
			},
			padding: {},
			onrendered: function () {
				d3.selectAll('.c3-axis-x-label').attr('transform', 'translate(0,10)');
			},
		});
	}
}
